import * as React from "react";
import styles from "./outlineButton.module.css";

function OutlineButton({ name, clickHandler, className, dataDismiss, disabled="", ...props }) {
  return <button type="button" disabled={disabled} className={`btn btn-outline-primary ${styles.btnOutline} ${className}`} onClick={clickHandler} data-dismiss={dataDismiss} {...props}>{name}</button>;
}
export default OutlineButton;
